import React, { useContext, useCallback, useState } from 'react'

import { connect } from 'react-redux'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { QuotaFormModalContext, Types } from '../../../../Providers/Forms/QuotaForm/QuotaFormModalProvider'
import { Quota } from '../../../../utils/entities/quota'
import DisplacementDatePicker from '../../../../Components/institution/Quotas/shared/DisplacementDatePicker'
import IconButton from '../../../../Components/antd/Buttons/IconButton'
import QuotasTableSettings from './QuotasTableSettings'

import '../../../../Components/institution/Quotas/assets/quotas.scss'

const mapDispatchToProps = state => ({ t: selectTranslate(state) })

const SchoolQuotaHeader = ({
  period, isYearly, sector, overlaySettings,
  onPeriodChange, onDateChange, onOverlaySettingsSelection, onQuotaChange, onIsYearlyChange, onResetGravity, t
}) => {
  const { setFormHandler } = useContext(QuotaFormModalContext)

  const [isSettingsVisible, setIsSettingsVisible] = useState(false)
  const [isOverlayMenuVisible, setIsOverlayMenuVisible] = useState(false)

  const hideOverlayMenuAndDo = useCallback(callback => isVisible => {
    if (isFunction(callback)) {
      callback(isVisible)
    }
    if (isOverlayMenuVisible) {
      setIsOverlayMenuVisible(false)
    }
  }, [isOverlayMenuVisible])

  const handleAddClick = useCallback(() => {
    const quota = new Quota({
      sector,
      startDate: period?.startDate,
      endDate: period?.endDate,
      total: 0
    })

    setFormHandler(handler => ({ ...handler, data: quota, callback: onQuotaChange, type: Types.BULK }))
  }, [sector, period, setFormHandler, onQuotaChange])

  return (
    <div className='school-quotas-header flex-row mb-8'>
      <IconButton
        key='settings'
        icon={faPlus}
        disabled={!sector}
        text={t('quota_table_menu.buttons.add_quota')}
        onClick={handleAddClick}
      />

      <div className='h-spacing' />

      <QuotasTableSettings
        overlayPrefix='school_quotas_view.overlay_option.'
        visible={isSettingsVisible}
        period={period}
        isYearly={isYearly}
        overlaySettings={overlaySettings}
        overlayMenuVisible={isOverlayMenuVisible}
        onClick={setIsSettingsVisible}
        onVisibleChange={hideOverlayMenuAndDo(setIsSettingsVisible)}
        onPeriodChange={onPeriodChange}
        onIsYealyChange={onIsYearlyChange}
        onOverlaySettingsSelection={onOverlaySettingsSelection}
        onOverlayMenuVisibleChange={setIsOverlayMenuVisible}
        onResetGravity={onResetGravity}
      />

      <div className='flex-fill' />

      <DisplacementDatePicker
        date={period.startDate}
        timePeriod={period.type}
        onDateChange={onDateChange}
      />
    </div>
  )
}

export default connect(mapDispatchToProps)(SchoolQuotaHeader)
